const SunValleyTitleHomeTextBlock = () => {

    return (
        <p className="lh-base">We know you have a choice&mdash;and your choice matters. Sun Valley Title is a title and escrow company serving Ketchum, Idaho and all of Blaine County. For more than 100 years, we've been providing title insurance, escrow, closing, foreclosure, settlement and 1031 services for the Sun Valley area.</p>
    );
}

export default SunValleyTitleHomeTextBlock;